module.exports = __webpack_public_path__ + "static/media/crannog.a7236394.png";